import styled from 'styled-components';

export const StyledSuggestedActionsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
`;

export const StyledSuggestedActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  border: 1px solid #b6b6b6;
  background: #b6b6b6;
  color: rgb(255, 255, 255);
  border-radius: 1.25rem;
  padding: 0.375rem 0.875rem;
  font-size: 0.781rem;
  font-weight: 600;
  line-height: 1.3;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: color-mix(in srgb, #b6b6b6 80%, black);
    border-color: color-mix(in srgb, #b6b6b6 80%, black);
  }
`;
